module.exports = __webpack_public_path__ + "media/brands/bova-c58fc9a9.png";